import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'tools',
  name: 'BusinessTools',
  component: EmptyRouterAlive,
  meta: {
    title: '工具',
  },
  children: [
    /**     ****** 运费计算器    ******** */
    {
      path: 'rateCalculator',
      name: 'BusinessrateCalculator',
      component: EmptyRouter,
      redirect: 'rateCalculator/index',
      meta: { title: '运费计算器', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessrateCalculator',
          component: () => import('@/views/center-business/tools/rateCalculator'),
          meta: { title: '运费计算器', isCache: true },
        },
        {
          path: 'view',
          name: 'BusinessFreightCalculationDetails',
          component: () => import('@/views/center-business/tools/rateCalculator/view.vue'),
          meta: { title: '运费计算器详情', isCache: false },
        },
      ],
    },
    /**     ****** 利润计算器    ******** */
    {
      path: 'profitCalculator',
      name: 'BusinessProfitCalculator',
      component: EmptyRouter,
      redirect: 'profitCalculator/index',
      meta: { title: '利润计算器', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessProfitCalculator',
          component: () => import('@/views/center-business/tools/profitCalculator'),
          meta: { title: '利润计算器', isCache: true },
        },
      ],
    },
    {
      path: 'SendEmail',
      name: 'BusinessSendEmail',
      component: EmptyRouter,
      redirect:'SendEmail/index',
      meta: { title: '群发邮件', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessSendEmail',
          component: () => import('@/views/center-business/tools/SendEmail'),
          meta: { title: '群发邮件', isCache: true },
        }
      ],
    },
    {
      path: 'SystemOnlineNtf',
      name: 'BusinessSystemOnlineNotification',
      component: EmptyRouter,
      redirect: 'SystemOnlineNtf/index',
      meta: {
        title: '系统上线通知',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessSystemOnlineNotification',
          component: (resolve) => require(['@/views/center-business/tools/systemOnlineNtf'], resolve),
          meta: {
            title: '系统上线通知',
            isCache: true,
          },
        },
        {
          path: 'add',
          name: 'BusinessSystemOnlineNotificationDetailAdd',
          component: (resolve) => require(['@/views/center-business/tools/systemOnlineNtf/add'], resolve),
          meta: {
            title: '新增通知详情',
            isCache: true,
          },
        },
        {
          path: 'edit',
          name: 'BusinessSystemOnlineNotificationDetailEdit',
          component: (resolve) => require(['@/views/center-business/tools/systemOnlineNtf/edit'], resolve),
          meta: {
            title: '编辑通知详情',
            isCache: true,
          },
        },
      ],
    },
  ],
};
